export const gamesPage = {
    'games.page.title': 'Games',
}
